import { isProduction } from '@/components/signup/utils/environment';

const LOOM_TWC_WELCOME_URL = 'https://www.loom.com/twc/welcome';
const LOOM_TWC_WELCOME_STAGING_URL = 'https://stage.loom.com/twc/welcome';

export const getLoomTwcWelcomeUrl = (siteId: string) => {
	const url = new URL(isProduction() ? LOOM_TWC_WELCOME_URL : LOOM_TWC_WELCOME_STAGING_URL);
	url.searchParams.set('siteId', siteId);
	return url.toString();
};
